// @flow

import { action } from "mobx";

import Store from "app/stores/Store";
import AppearanceStore from "app/stores/AppearanceStore";

import FeedbackService from "app/services/FeedbackService";

class FeedbackStore extends Store {
    @action.bound create(comment: string): Promise<*> {
        return FeedbackService.create(comment).then(
            ({ data }) => {
                AppearanceStore.notifySuccess(data.message);
            },
            ({ response }: any) => {
                AppearanceStore.notifyError(response.data.message);
            }
        );
    }
}

export default new FeedbackStore();



// WEBPACK FOOTER //
// ./src/app/stores/FeedbackStore.js